document.addEventListener('DOMContentLoaded', () => {
  const recommendationBlocks = document.querySelectorAll('product-recommendations[data-url]');

  function initProductRecommendationSlider(scope = document) {
    scope.querySelectorAll('[data-dr-pr-slider]').forEach((slider) => {
      if (slider.dataset.sliderInitialized === 'true') return;
      slider.dataset.sliderInitialized = 'true';

      const track = slider.querySelector('[data-dr-pr-slider-track]');
      const prev = slider.querySelector('[data-dr-pr-slider-prev]');
      const next = slider.querySelector('[data-dr-pr-slider-next]');

      if (!track || !prev || !next) return;

      function getScrollAmount() {
        const card = track.querySelector('.dr-pr-card');
        if (!card) return track.clientWidth;

        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return card.offsetWidth + gap;
      }

      function updateArrows() {
        const maxScrollLeft = track.scrollWidth - track.clientWidth;
        const currentScroll = track.scrollLeft;

        prev.disabled = currentScroll <= 5;
        next.disabled = currentScroll >= maxScrollLeft - 5;
      }

      prev.addEventListener('click', () => {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      next.addEventListener('click', () => {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);

      updateArrows();
    });
  }

  recommendationBlocks.forEach(async (block) => {
    const url = block.dataset.url;
    if (!url) return;

    try {
      const response = await fetch(url);
      if (!response.ok) return;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newBlock = doc.querySelector('product-recommendations');

      if (newBlock && newBlock.innerHTML.trim() !== '') {
        block.innerHTML = newBlock.innerHTML;

        initProductRecommendationSlider(block);
      }
    } catch (error) {
      console.error('Errore recommendations:', error);
    }
  });
});